import { render } from "./OtiActionsSmall.vue?vue&type=template&id=252f5049&scoped=true"
import script from "./OtiActionsSmall.vue?vue&type=script&lang=js"
export * from "./OtiActionsSmall.vue?vue&type=script&lang=js"

import "./OtiActionsSmall.vue?vue&type=style&index=0&id=252f5049&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252f5049"]])

export default __exports__